import { Panel } from "primereact/panel"
import { InfoClienteService } from "../../service/matriz/InfoClienteService";
import { useForm } from "react-hook-form";
import { useEffect, useRef, useState } from "react";
import { Generico } from "../../components/Generico";
import { MatrizComponent } from "../../components/MatrizComponent";
import { DetailedCellError, HyperFormula } from "hyperformula";
import { ProgressSpinner } from 'primereact/progressspinner';

export const DetalleCliente = ({ matrizId, permss, setDialogPerfil, toast, tipo, regresar, funcionalidades }) => {
    const { control, formState: { errors }, handleSubmit, reset, setError } = useForm({});
    const clienteSrv = new InfoClienteService();
    const [matriz, setMatriz] = useState(null);
    const hfInstanceRef = useRef(null);
    const [loadSave, setLoadSave] = useState(false);
    const { funcErrorHibrida, funcSuccess, funcMessageBlobError, downloadPdf, limpiarNombre } = Generico();
    const [loadReport, setLoadReport] = useState(false);
    const [color, setColor] = useState(null);
    const [catalogos, setCatalogos] = useState(null);
    const [lista, setLista] = useState(null);
    const [loadCambio, setLoadCambio] = useState(false);
    const { numericRound, resume, onError, buttonsMatriz, cabecera, scolor, pie, factor, cabeceraAcelerador, acelerador, infoColor, infoSenial2,
        infoSenialCli1, infoSenialControl, infoSenialCli2 } = MatrizComponent({ control, errors, permss, toast, funcionalidades });
    const [loadingDatos, setLoadingDatos] = useState(true);

    useEffect(() => {
        hfInstanceRef.current = HyperFormula.buildEmpty({ licenseKey: 'gpl-v3' });
        hfInstanceRef.current.addSheet('Sheet1');
        verificarMatriz();
        return () => {
            hfInstanceRef.current.destroy();
        };
    }, [matrizId]);

    const onSubmit = (data) => {
        setLoadSave(true);
        const _matriz = matriz;
        _matriz.id = matrizId;
        _matriz.values = data;
        clienteSrv.detalle(_matriz, tipo).then(res => {
            setLoadSave(false);
            funcSuccess(res, toast);
        }).catch(error => {
            setLoadSave(false);
            funcErrorHibrida(error, toast, setError);
        });
    }

    const verificarMatriz = () => {
        clienteSrv.informacion(matrizId, tipo).then(res => {
            const _info = res.data;
            const _cat = _info?.catalogos;
            const _values = {};
            setColor(_info?.color);
            setCatalogos(_cat);
            const formulas = [];
            const data = [];
            let index = 0;
            const lista = {
                'cli1-1-valor': _cat?.TIPO_ESTRUCTURA_LEGAL,
                'ope7-7-valor': _cat?.TIPO_BIEN,
                'ftr12-12-valor': _cat.TIPO_TRANSACCION,
                'ftr13-13-valor': _cat.INSTRUMENTO_MONETARIO,
                'ftr14-14-valor': _cat.CANAL_SERVICIO_BIEN,
                'fcr22-22-valor': _cat?.OTRAS_SENIALES,
                'sen28-28-valor': _cat?.CONTROL,
                'sen29-29-valor': _cat?.CONTROL,
                'sen30-30-valor': _cat?.CONTROL,
                'sen31-31-valor': _cat?.CONTROL
            };
            Object.keys(_info).map((key) => {
                const siMatriz = key.includes('cli') || key.includes('ope') || key.includes('ftr') || key.includes('fcr') || key.includes('sen');
                if (siMatriz) {
                    const orden = parseInt(_info[key].orden);
                    if (orden === 8) {
                        valueCell('monto', _info[key]?.calculado1 ? parseFloat(_info[key]?.calculado1) : 0, 7);
                    }
                    const valor = orden === 34 ? (_info[key]?.valor === 1 ? 'SI' : 'NO') : parseFloat(_info[key]?.valor);
                    data.push([valor, parseFloat(_info[key]?.puntaje), parseFloat(_info[key]?.ponderacion)]);
                    const ccol = [8, 18, 19, 20, 21, 23, 24, 25, 26, 32, 33, 35, 36, 37, 38].includes(orden) ? 0 : 2;
                    if (_info[key]?.formula1) formulas.push({ value: _info[key]?.formula1, row: index, col: ccol });
                    if (_info[key]?.formula) formulas.push({ value: _info[key]?.formula, row: index, col: 1 });
                    if ([28, 29, 30, 31].includes(orden)) {
                        const val = _info[key]?.valor;
                        _values[`${key}-${orden}-valor`] = (val === "0" || val === 0) ? null : parseInt(val);
                    }
                    else if (_info[key]?.nemonico) _values[`${key}-${orden}-valor`] = _info[key]?.catalogo;
                    else if (orden === 34) {
                        const _label = _info[key]?.calculado2;
                        _values[`${key}-${orden}-valor`] = _info[key]?.valor === 1 ? { valor: 'SI', nombre: _label ?? 'SI' } : { valor: 'NO', nombre: _label ?? 'NO' };
                        _info[key].ponderacion = _info[key]?.calculado1;
                    }
                    else if (orden === 35) {
                        _values[`${key}-${orden}-puntaje`] = _info[key]?.calculado1 ?? '';
                        _info[key].valor = _info[key]?.calculado2;
                    }
                    else if (_info[key]?.form1) _values[`${key}-${orden}-valor`] = _info[key]?.valor;
                    if (orden === 8) {
                        _values[`${key}-${orden}-valor`] = _info[key]?.calculado1;
                    }
                    if ([25, 26, 33, 37, 38].includes(orden)) _info[key].valor = _info[key]?.calculado1;

                    //Color
                    const vcolor = [6, 11, 17].includes(orden) ? _info[key]?.puntaje : _info[key]?.valor;
                    _info[key].color = scolor(vcolor, _info?.color);

                    delete _info[key]?.formula;
                    delete _info[key]?.formula1;
                    index++;
                }
                return 1;
            });

            Object.keys(lista).forEach(function (key) {
                if (_values[key] != null) {
                    const catalogo = lista[key];
                    let encontrado = false;
                    if (Array.isArray(catalogo)) { // Validamos que el catálogo exista y sea un arreglo antes de buscar
                        for (let i = 0; i < catalogo.length; i++) {
                            if (catalogo[i].cat_id === _values[key]) {
                                _values[key] = catalogo[i];
                                encontrado = true;
                                break;
                            }
                        }
                    }
                    if (!encontrado) { // Si no se encontró el ID en el catálogo, lo dejamos en null
                        _values[key] = null;
                    }
                }
            });

            hfInstanceRef.current.setCellContents(
                { sheet: 0, col: 0, row: 0 },
                data
            );
            formulas.forEach((formula) => {
                hfInstanceRef.current.setCellContents(
                    { sheet: 0, col: formula.col, row: formula.row },
                    [[formula.value]]
                );
            });
            const _color = _info.color;
            delete _info.color;
            delete _info.catalogos;
            setMatriz(_info);
            reset(_values);

            //Para cargas masivas
            if (parseFloat(_info.cli6.puntaje) <= 0) {
                const _valorCliente = parseFloat(_info.cli3.puntaje) + parseFloat(_info.cli4.puntaje) + parseFloat(_info.cli5.puntaje);
                if (_valorCliente > 0) {
                    calcular(_info.ope8.calculado1, 'ope8-8-valor', _info, _color);
                }
            }
        }).catch(error => {
            if (error.response.data.message) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, sticky: true });
                setDialogPerfil(false);
            }
            else {
                funcErrorHibrida(error, toast, setError);
            }
        }).finally(() => setLoadingDatos(false));
    }

    const valueCell = (field, value, row) => {
        const cols = { valor: 0, puntaje: 1, ponderacion: 2, monto: 3 };
        if (value !== null && value !== undefined) {
            hfInstanceRef.current.setCellContents({ sheet: 0, col: cols[field], row: row }, [[value]]);
        }
        const calculatedValue = hfInstanceRef.current.getCellValue({ sheet: 0, col: cols[field], row: row });
        if (calculatedValue instanceof DetailedCellError) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: `Error: ${calculatedValue.type}, Message: ${calculatedValue.message}, field: ${field}, value: ${value}, row: ${row}`, life: 3000 });
            return null;
        }

        return numericRound(calculatedValue)
    }

    const calcular = (value, name, mmatriz = null, ccolor = null) => {
        const _matriz = mmatriz ?? matriz;
        const _color = ccolor ?? color;

        const [key, orden, field] = name.split('-');
        const rrow = parseInt(orden) - 1;
        let val = value?.valor ?? (value?.cat_id ?? 0);
        const _item = _matriz[key];
        if (parseInt(orden) === 8) {
            valueCell('monto', value, rrow);
            val = null;
        } else if (parseInt(orden) === 35) {
            _item.puntaje = valueCell('puntaje', val, rrow);
        } else {
            _item.valor = valueCell(field, val, rrow);
            _item.puntaje = valueCell('puntaje', null, rrow);
        }
        _item.valor = valueCell(field, val, rrow);
        _item.color = scolor(_item?.valor, _color);
        _item.puntaje = valueCell('puntaje', null, rrow);
        setMatriz(prevItem => ({
            ...prevItem,
            [key]: _item
        }));

        const tips = ['cli', 'ope', 'ftr', 'fcr'];
        const arrs = [6, 11, 17, 23, 24, 25, 26, 35, 36, 37, 38];
        for (let i = 0; i < arrs.length; i++) {
            const _tip = arrs[i] > 23 ? 'sen' : tips[i];
            const _cal = _matriz[`${_tip}${arrs[i]}`];
            if (arrs[i] <= 23) _cal.puntaje = valueCell('puntaje', null, arrs[i] - 1);

            if (arrs[i] >= 23) {
                _cal.valor = valueCell('valor', null, arrs[i] - 1);
                if ([25, 26].includes(arrs[i])) {
                    _cal.color = _matriz?.sen24?.color;
                } else if ([37, 38].includes(arrs[i])) {
                    _cal.color = _matriz?.sen36?.color;
                } else {
                    _cal.color = scolor(_cal?.valor, _color);
                }
            } else if ([6, 11, 17].includes(arrs[i])) {
                _cal.color = scolor(_cal?.puntaje, _color);
            }
        }
        for (let i = 18; i <= 21; i++) {
            const _cal = _matriz[`fcr${i}`];
            _cal.valor = valueCell('valor', null, i - 1);
            _cal.color = scolor(_cal?.valor, _color);
        }
        const asol = [32, 33];
        for (let i = 0; i < asol.length; i++) {
            const _cal = _matriz[`sen${asol[i]}`];
            _cal.valor = valueCell('valor', null, asol[i] - 1);
        }
        //Inx: 34
        const _cal = _matriz['sen34'];
        _cal.ponderacion = valueCell('ponderacion', null, 33);//índice inicia en 0
        _cal.color = scolor(_cal?.ponderacion, _color);
        if (!matriz) {
            setMatriz(_matriz);
        }
    }

    const generarReporte = () => {
        setLoadReport(true);
        const nombreArchivo = `Matriz Cliente - ${limpiarNombre(matriz.nombres)}.pdf`;
        clienteSrv.descargar(matrizId, tipo).then(res => {
            downloadPdf(res, nombreArchivo);
            setLoadReport(false);
        }).catch(error => {
            setLoadReport(false);
            funcMessageBlobError('Asegúrese de ingresar la información antes de generar el reporte.', error, toast);
        });
    }

    const search = (event, inf) => {
        if (!event.query.trim().length) {
            setLista([...lista]);
        }
        else {
            const vals = inf.split("-");
            const empresaId = matriz.empresa_id;
            const tipoNegocioId = matriz.tipo_negocio_id;
            clienteSrv.getLista(event.query.toLowerCase(), vals[0], vals[1], empresaId, tipoNegocioId, tipo).then(data => {
                setLista(data.data);
            });
        }
    }

    const finalizar = () => {
        setLoadCambio(true);
        clienteSrv.finalizar({ id: matrizId, estado: 'BORRADOR', cambio: 'a' }, tipo).then(res => {
            setLoadCambio(false);
            funcSuccess(res, toast);
            regresar();
        }).catch(error => {
            setLoadCambio(false);
            funcErrorHibrida(error, toast, setError);
        });
    }

    return (
        <>
            {loadingDatos ? (
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100vh", textAlign: "center", gap: "20px" }}>
                    <h2 style={{ fontSize: "16px", fontWeight: "bold", textTransform: "uppercase", letterSpacing: "1px" }}>
                        Cargando datos...
                    </h2>
                    <ProgressSpinner style={{ width: '70px', height: '70px' }} strokeWidth="6" fill="var(--surface-ground)" animationDuration="4s" />
                </div>
            ) : (
                <Panel header="Matriz" style={{ maxWidth: '800px', margin: 'auto' }} className="panel-ficha">
                    <form onSubmit={handleSubmit(onSubmit, onError)}>
                        <div className="grid grid-nogutter">
                            {resume(1, matriz?.empresa, 12, 1, true, '2xl')}
                            {resume(2, matriz?.nombre_plantilla, 12, 1, true, '2xl')}
                            {resume(3, `FECHA DE ANÁLISIS: ${matriz?.fecha}`, 12, 1, true, null, 'center', null, 'border-bottom-1')}
                            {resume(4, 'INFORMACIÓN DEL CLIENTE', 12, 0, true, '2xl', 'center', null, 'border-bottom-1')}
                            {resume(5, 'NOMBRE/RAZÓN SOCIAL:', 4, 0, true, 'sm', 'center', null, 'border-1')}
                            {resume(6, matriz?.nombres, 7, 0, false, 'sm', 'center', 'blue-100', 'border-1')}
                            {resume(7, 'IDENTIFICACIÓN:', 4, 0, true, 'sm', 'center', null, 'border-1')}
                            {resume(8, matriz?.identificacion, 5, 0, false, 'sm', 'center', 'blue-100', 'border-1')}
                        </div>
                        <br />

                        <Panel header="CLIENTE" style={{ width: '100%', margin: 'auto' }}>
                            <div className="formgrid grid align-items-center justify-content-center">
                                {cabecera()}
                                {matriz && factor('cli1-1-valor', catalogos?.TIPO_ESTRUCTURA_LEGAL, matriz, calcular, 'drop')}
                                {matriz && factor('cli2-2-valor', lista, matriz, calcular, 'complete', search)}
                                {matriz && factor('cli3-3-valor', lista, matriz, calcular, 'complete', search)}
                                {matriz && factor('cli4-4-valor', lista, matriz, calcular, 'complete', search)}
                                {matriz && factor('cli5-5-valor', lista, matriz, calcular, 'complete', search)}
                                {matriz && pie('VALOR CLIENTE:', 'cli6', matriz)}
                            </div>
                        </Panel>

                        <br />

                        <Panel header="OPERACIÓN" style={{ width: '100%', margin: 'auto' }}>
                            <div className="formgrid grid align-items-center justify-content-center">
                                {cabecera()}
                                {matriz && factor('ope7-7-valor', catalogos?.TIPO_BIEN, matriz, calcular, 'drop')}
                                {matriz && factor('ope8-8-valor', lista, matriz, calcular, 'number')}
                                {matriz && factor('ope9-9-valor', lista, matriz, calcular, 'complete', search)}
                                {matriz && factor('ope10-10-valor', lista, matriz, calcular, 'complete', search)}
                                {matriz && pie('VALOR OPERACION:', 'ope11', matriz)}
                            </div>
                        </Panel>
                        <hr />

                        <Panel header="TRANSACCIÓN" style={{ width: '100%', margin: 'auto' }}>
                            <div className="formgrid grid align-items-center justify-content-center">
                                {cabecera()}
                                {matriz && factor('ftr12-12-valor', catalogos?.TIPO_TRANSACCION, matriz, calcular, 'drop')}
                                {matriz && factor('ftr13-13-valor', catalogos?.INSTRUMENTO_MONETARIO, matriz, calcular, 'drop')}
                                {matriz && factor('ftr14-14-valor', catalogos?.CANAL_SERVICIO_BIEN, matriz, calcular, 'drop')}
                                {matriz && factor('ftr15-15-valor', lista, matriz, calcular, 'complete', search)}
                                {matriz && factor('ftr16-16-valor', lista, matriz, calcular, 'complete', search)}
                                {matriz && pie('VALOR TRANSACCION:', 'ftr17', matriz)}
                            </div>
                        </Panel>
                        <hr />

                        <Panel header="FACTOR ACELERADOR" style={{ width: '100%', margin: 'auto' }}>
                            <div className="formgrid grid justify-content-center">
                                {cabeceraAcelerador()}
                                {matriz && acelerador(matriz, 'fcr18', 'cli2')}
                                {matriz && acelerador(matriz, 'fcr19', 'cli3')}
                                {matriz && acelerador(matriz, 'fcr20', 'cli4')}
                                {matriz && acelerador(matriz, 'fcr21', 'ftr16')}
                                {cabeceraAcelerador(false)}
                                {matriz && acelerador(matriz, 'fcr22', 'fcr22', 'fcr22-22-valor', catalogos?.OTRAS_SENIALES, calcular)}
                                {cabeceraAcelerador(false)}
                                {matriz && acelerador(matriz, 'fcr23', 'fcr23', valueCell('puntaje', null, 22))}
                            </div>
                        </Panel>
                        <hr />

                        <Panel header="RESULTADOS" style={{ width: '100%', margin: 'auto' }}>
                            <div className="formgrid grid justify-content-center">
                                <div className="col-3">
                                    <div className="formgrid grid justify-content-center">
                                        {color && infoColor(color)}
                                    </div>
                                </div>

                                <div className="col-9">
                                    <div className="formgrid grid justify-content-center">
                                        {matriz && infoSenialCli1(matriz)}
                                        <div className="field col-4 m-0 text-center text-xs font-bold border-1">
                                            <div className="formgrid grid justify-content-center">
                                                {matriz && infoSenialControl(catalogos, calcular)}
                                            </div>
                                        </div>

                                        {matriz && infoSenialCli2(matriz, calcular)}
                                        {matriz && infoSenial2(matriz)}
                                    </div>
                                </div>
                            </div>
                        </Panel>

                        <br />
                        {buttonsMatriz({
                            permss, btn1: { setDlg: (valor) => { regresar(); setDialogPerfil(valor); } }, btn2: { loadSave }, btn3: { loadReport, chn: generarReporte },
                            btn4: { msg: <>Asegúrese de guardar la matriz antes de finalizar.<br />¿Desea finalizar la matriz?</>, chn: finalizar, loadCambio }
                        })}
                    </form>
                </Panel>
            )}
        </>
    )
}
